import React, { useEffect, useState } from 'react'
import { pageTitle } from '../helper'
import PageHeading from '../components/PageHeading'
import PricingTableList from '../components/PricingTable/PricingTableList'
import Div from '../components/Div'
import Spacing from '../components/Spacing'
import { Alert, Button } from 'react-bootstrap'
import axiosInstance from '../api/axiosRest'
import { SUBSCRIPTION } from '../api/urls'

export default function ServicesPage() {
  const [paymentIssue, setPaymentIssue] = useState(false)
  const [planExpired, setPlanExpired] = useState(false)

  pageTitle('Pricing')

  useEffect(() => {
    window.scrollTo(0, 0)

    const checkPaymentIssue = async () => {
      try {
        const token = localStorage.getItem('access_token')
        if (!token) return // user not logged in

        const res = await axiosInstance.get(SUBSCRIPTION.STATUS)
        const { subscriptions } = res.data

        if (subscriptions !== 'none' && Array.isArray(subscriptions)) {
          let issue = false
          let expired = false
          subscriptions.forEach((s) => {
            const status = (s.subscription_status || '').toLowerCase()
            if (['past_due', 'incomplete', 'unpaid', 'incomplete_expired'].includes(status)) {
              issue = true
            }
            if (status === 'expired') {
              expired = true
            }
          })
          setPaymentIssue(issue)
          setPlanExpired(expired)
        }
      } catch (err) {
        console.error('Error checking subscription status on pricing page', err)
      }
    }

    checkPaymentIssue()
  }, [])

  return (
    <>
      {paymentIssue && (
        <Alert variant="danger" className="text-center m-0 rounded-0">
          <strong>Payment Failed:</strong> Your last payment attempt was declined. Please try again with a Visa or MasterCard, or update your payment information below.
        </Alert>
      )}
      {planExpired && (
        <Alert variant="warning" className="text-center m-0 rounded-0">
          <strong>Plan Expired:</strong> Your plan has expired. Please resubscribe to continue our services.
        </Alert>
      )}
      <PageHeading 
        title='Pricing'
        bgSrc='images/service_hero_bg.jpeg'
        pageLinkText='Pricing'
      />
    
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Spacing lg='85' md='60'/>
        <div id="pricing-table-plans">
          <PricingTableList/>
        </div>
      </Div>
    
    </>
  )
}
